<template>
    <main :class="{ shifted }">
        <router-view :key="$route.fullPath" />
    </main>
</template>

<script>
export default {
    name: 'AppMain',
    props: {
        shifted: {
            type: Boolean,
        }
    },

    methods: {
    },
};
</script>

<style scoped lang="scss"></style>
